import { SearchOutlined } from "@ant-design/icons";
import { _useReport } from "hooks";

const HorizontalNav = () => {
  const { setFilterModal } = _useReport();

  return (
    <div
      className="flex justify-center items-center gx-w-100"
      style={{ height: "3rem" }}
    >
      <div
        className="flex items-center"
        style={{ gap: "0.25rem", cursor: "pointer" }}
        onClick={() => setFilterModal(true)}
      >
        <SearchOutlined className="text-2xl" />
        <p className="gx-mb-0 fs_16 md:flex hidden">Click Filter</p>
      </div>
    </div>
  );
};

HorizontalNav.propTypes = {};

export default HorizontalNav;
